<template>
  <div class="layer layer2">
    <div class="inner">
      <button type="button" class="btnClose" @click="close"></button>
      <h2 class="layerTitle">{{locale.product_promotion_manage}}</h2>
      <div class="flexBox">
        <!-- 설정 -->
        <div class="flexInner">
          <div class="mb15 isRequired">
            <div class="innerTitle setLabel">{{locale.name}}</div>
            <input type="text" class="input" v-model="name">
          </div>
          <div class="mb30 isRequired">
            <div class="innerTitle setLabel">{{locale.type}}</div>
            <div class="checkbox radio">
              <input type="radio" name="promotion_type" id="promotion_type_text" value="text" v-model="promotionType">
              <label for="promotion_type_text">{{ locale.text }}</label>
            </div>
            <div class="checkbox radio">
              <input type="radio" name="promotion_type" id="promotion_type_image" value="image" v-model="promotionType">
              <label for="promotion_type_image">{{ locale.image }}</label>
            </div>
          </div>
          <!-- 텍스트타입 -->
          <div v-if="promotionType === 'text'">
            <div class="flexBox isRequired mb15">
              <div class="flexInner">
                <div class="innerTitle setLabel">{{ locale.text }}</div>
                <input type="text" class="input" v-model="text.value" />
              </div>
              <div class="flexInner">
                <div class="innerTitle setLabel">{{ locale.font_size }}</div>
                <select class="input select" v-model="text.fontSize">
                  <option
                    v-for="(size, index) in fontSizes"
                    :key="index"
                    :value="size">
                    {{ size }}
                  </option>
                </select>
              </div>
            </div>
            <div class="flexBox isRequired mb30">
              <div class="flexInner">
                <div class="innerTitle setLabel">{{ locale.text_color }}</div>
                <ColorPicker class="mt5" @changeColor="changeColor('textColor', $event)" :color="text.textColor" />
              </div>
              <div class="flexInner">
                <div class="innerTitle setLabel">{{ locale.background_color }}</div>
                <ColorPicker class="mt5" @changeColor="changeColor('backgroundColor', $event)" :color="text.backgroundColor" />
              </div>
            </div>
          </div>
          <!-- //텍스트타입 -->
          <!-- 이미지타입 -->
          <div v-else>
            <div class="flexBox isRequired mb30">
              <div class="flexInner">
                <div class="innerTitle setLabel">{{locale.image}}</div>
                <div v-if="image.value" class="bgThumb">
                  <img :src="image.value" alt="" />
                  <button type="button" class="delThumb" @click="deleteImage"><img src="~@/assets/img/ico_close.svg" alt=""></button>
                </div>
                <div v-else><label class="btn btnFull btnWhite toUppercase">{{locale.upload}}<input type="file" @change="uploadImage($event)"></label></div>
              </div>
              <div class="flexInner"></div>
            </div>
            <div>
              <div class="innerTitle setLabel">{{locale.size}}</div>
                <p class="infoMessage mb10">{{ locale.message_promotion_position }}<br>{{ locale.message_adjust_ratio }}</p>
                <div class="unitInput iconSize">
                  <span class="unitLabel">{{locale.horizontal_size}}</span>
                  <input type="text" class="input" v-model="image.size">
                  <i class="unit">px</i>
                </div>
            </div>
          </div>
          <!-- //이미지타입 -->
        </div>
        <!-- //설정 -->
        <!-- 미리보기 -->
        <div class="flexInner">
          <div class="promotionPreview">
            <div class="innerTitle setLabel">{{ locale.preview }}</div>
            <div class="mb5">
              <div class="checkbox radio">
                <input type="radio" name="promotion_preview" id="promotion_preview_dark" value="dark" v-model="previewType">
                <label for="promotion_preview_dark">{{ locale.dark }}</label>
              </div>
              <div class="checkbox radio">
                <input type="radio" name="promotion_preview" id="promotion_preview_white" value="white" v-model="previewType">
                <label for="promotion_preview_white">{{ locale.light }}</label>
              </div>
            </div>
            <p class="infoMessage mb10">{{ locale.message_promotion_set_position }}</p>
            <div class="previewOrderItem">
              <div class="thumb" :class="previewType">
                <div
                  class="stkr"
                  :style="getStkrStyle">
                  <span v-if="promotionType === 'text'">{{ text.value }}</span>
                  <img v-else :src="image.value" alt="">
                </div>
                <label
                  v-for="(pos, index) in positions"
                  :key=index
                  :for="`stkr_pos_${pos}`"
                  :class="[pos, {isActive: pos === position}]"
                  class="promotionPosition">
                  <input
                    type="radio"
                    :id="`stkr_pos_${pos}`"
                    :value="pos"
                    v-model="position">
                </label>
              </div>
            </div>
          </div>
        </div>
        <!-- //미리보기 -->
      </div>
      <div class="btns">
        <button type="button" class="btn btnWhite" @click="close">{{ locale.cancel }}</button>
        <button type="button" class="btn btnPrimary" :disabled="!isValid" @click="save">{{ locale.save }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import LANG from '@/common/lang'
import UNIQUE from '@/common/unique'
import regExp from '@/common/regExp'
import ColorPicker from '@/components/Util/ColorPicker.vue'

export default {
  name: 'CompositePromotion',
  props: [
    'locale',
    'presetId'
  ],
  components: {
    ColorPicker
  },
  computed: {
    getStkrStyle () {
      return {
        ...this.promotionType === 'text' && {
          fontSize: this.text.fontSize,
          color: this.text.textColor,
          backgroundColor: this.text.backgroundColor
        },
        ...this.promotionType === 'image' && {
          width: `${this.image.size}px`,
          padding: '0',
          fontSize: '0'
        },
        ...this.getPositionStyle
      }
    },
    getPositionStyle () {
      const position = this.position
      let result = {
        top: 0,
        right: 0
      }
      switch (position) {
        case 'tl':
          result = {
            top: 0,
            left: 0
          }
          break
        case 'tr':
          result = {
            top: 0,
            right: 0
          }
          break
        case 'br':
          result = {
            bottom: 0,
            right: 0
          }
          break
        case 'bl':
          result = {
            bottom: 0,
            left: 0
          }
          break
      }
      return result
    },
    textStkrStyle () {
      return {
        fontSize: this.text.fontSize,
        color: this.text.textColor,
        backgroundColor: this.text.backgroundColor,
        ...this.getPositionStyle
      }
    },
    imgStkrStyle () {
      return {
        width: `${this.image.size}px`,
        padding: '0',
        fontSize: '0',
        ...this.getPositionStyle
      }
    },
    isValid () {
      const name = regExp.replaceAllEmpty(this.name) !== ''
      const isValidText = this.promotionType === 'text'
        ? regExp.replaceAllEmpty(this.text.value) !== ''
        : true
      const isValidImage = this.promotionType === 'image'
        ? this.image.value !== ''
        : true
      return name && isValidText && isValidImage
    }
  },
  created () {
    if (this.presetId && this.presetId !== 'new') {
      this.getShopPresetDetail()
    }
  },
  data () {
    return {
      name: '',
      promotionType: 'text', // text, image
      text: {
        textColor: 'rgba(255, 255, 255, 1)',
        backgroundColor: 'rgba(20, 20, 20, 1)',
        fontSize: '16px',
        value: 'SAMPLE'
      },
      image: {
        size: '100',
        value: ''
      },
      fontSizes: ['12px', '14px', '16px', '18px', '20px'],
      positions: [ 'tr', 'br', 'bl' ],
      position: 'tr', // tl, tr, br, bl
      previewType: 'dark' // dark, white
    }
  },
  methods: {
    async getShopPresetDetail () {
      this.$store.commit('onLoading', true)
      const getDetail = await this.$store.dispatch('shop/getShopPresetDetail', {
        presetType: 'promotion',
        presetId: this.presetId
      })
      const detail = getDetail && getDetail.message
      if (detail && detail.presetId) {
        const promotion = detail.presetOptions[0]
        this.name = detail.presetName
        this.promotionType = promotion.type
        this.position = promotion.position
        this[promotion.type] = promotion[promotion.type]
      }
      this.$store.commit('onLoading', false)
    },
    changeColor (target, rgba) {
      this.text[target] = rgba
    },
    uploadImage (e) {
      const data = {
        id: UNIQUE.mid(),
        file: e.target.files[0]
      }
      const isImage = regExp.image.test(data.file.name.slice(data.file.name.lastIndexOf('.') + 1).toLowerCase())
      if (isImage) {
        this.$store.dispatch('util/uploadFile', data).then((res) => {
          this.image.value = res.source
          e.target.value = ''
        })
      } else {
        alert(this.locale.validate_upload_image)
      }
    },
    deleteImage () {
      this.image.value = ''
    },
    close () {
      this.$emit('close')
    },
    async save () {
      const presetId = this.presetId && this.presetId !== 'new' && this.presetId
      const data = {
        presetType: 'promotion',
        presetId: presetId || UNIQUE.uniqueId8(),
        presetName: this.name,
        presetOptions: [{
          id: UNIQUE.uniqueId8(),
          name: this.name,
          type: this.promotionType,
          position: this.position,
          ...this.promotionType === 'text' && {
            text: this.text
          },
          ...this.promotionType === 'image' && {
            image: this.image 
          }
        }]
      }
      this.$store.commit('onLoading', true)
      const res = await this.$store.dispatch('shop/putShopPreset', data)
      if (res && res.status === 200) {
        alert(this.locale.complete_save)
        this.$emit('reload', data.presetId)
        this.close()
      }
      this.$store.commit('onLoading', false)
    }
  }
}
</script>

<style lang="scss" scoped>
.layer {
  .inner {
    max-width: 800px;
    overflow: visible;
  }
}
.isRequired {
  .innerTitle {
    padding-left: 18px;
    &:after {
      content: "*";
      position: absolute;
      top: 0;
      left: 8px;
      color: $color-red;
    }
  }
}
.promotionPreview {
  .thumb {
    position: relative;
    width: 300px;
    height: 222px;
    overflow: hidden;
    border: 1px solid $color-lgrey2;
    border-radius: 8px;
    background: $color-white url('~@/assets/img/sample/shop_item_preview_dark.png') 50% 50% / cover no-repeat;
  }
  .stkr {
    position: absolute;
    padding: 4px 8px;
  }
  .dark {
    background-image: url('~@/assets/img/sample/shop_item_preview_dark.png');
  }
  .white {
    background-image: url('~@/assets/img/sample/shop_item_preview_white.png');
  }
  .promotionPosition {
    position: absolute;
    width: 100px;
    height: 100px;
    border: 1px dashed $color-white;
    border-radius: 8px;
    opacity: 0.5;
    cursor: pointer;
    &:before {
      content: "";
      position: absolute;
      top: -1px;
      left: -1px;
      right: -1px;
      bottom: -1px;
      border: 1px dashed rgba(0,0,0,0.2);
      border-radius: 8px;
    }
    &:hover {
      background-color: rgba($color-white, 0.5);
      opacity: 1;
    }
    &.tl {
      top: 0;
      left: 0;
    }
    &.tr {
      top: 0;
      right: 0;
    }
    &.br {
      bottom: 0;
      right: 0;
    }
    &.bl {
      bottom: 0;
      left: 0;
    }
  }
}
</style>
